import Albedo from "./geo/Albedo";
import Alhaitham from "./dendro/Alhaitham";
import Aloy from "./cryo/Aloy";
import Ayato from "./hydro/Ayato";
import Amber from "./pyro/Amber";
import AnemoMC from "./anemo/AnemoMC";
import Ayaka from "./cryo/Ayaka";
import Barbara from "./hydro/Barbara";
import Beidou from "./electro/Beidou";
import Bennett from "./pyro/Bennett";
import Candace from "./hydro/Candace";
import Collei from "./dendro/Collei";
import Chongyun from "./cryo/Chongyun";
import Cyno from "./electro/Cyno";
import DendroMC from "./dendro/DendroMC";
import Diluc from "./pyro/Diluc";
import Diona from "./cryo/Diona";
import Dori from "./electro/Dori";
import Eula from "./cryo/Eula";
import ElectroMC from "./electro/ElectroMC";
import Faruzan from "./anemo/Faruzan";
import Fischl from "./electro/Fischl";
import Ganyu from "./cryo/Ganyu";
import GeoMC from "./geo/GeoMC";
import Gorou from "./geo/Gorou";
import Heizou from "./anemo/Heizou";
import HuTao from "./pyro/HuTao";
import Itto from "./geo/Itto";
import Jean from "./anemo/Jean";
import Kazuha from "./anemo/Kazuha";
import Kaeya from "./cryo/Kaeya";
import Keqing from "./electro/Keqing";
import Klee from "./pyro/Klee";
import Kokomi from "./hydro/Kokomi";
import Layla from "./cryo/Layla";
import Lisa from "./electro/Lisa";
import Mona from "./hydro/Mona";
import Nahida from "./dendro/Nahida";
import Nilou from "./hydro/Nilou";
import Ningguang from "./geo/Ningguang";
import Noelle from "./geo/Noelle";
import Qiqi from "./cryo/Qiqi";
import Raiden from "./electro/Raiden";
import Razor from "./electro/Razor";
import Rosaria from "./cryo/Rosaria";
import Sara from "./electro/Sara";
import Sayu from "./anemo/Sayu";
import Shenhe from "./cryo/Shenhe";
import Shinobu from "./electro/Shinobu";
import Sucrose from "./anemo/Sucrose";
import Tartaglia from "./hydro/Tartaglia";
import Tighnari from "./dendro/Tighnari";
import Thoma from "./pyro/Thoma";
import Venti from "./anemo/Venti";
import Wanderer from "./anemo/Wanderer";
import Xiangling from "./pyro/Xiangling";
import Xiao from "./anemo/Xiao";
import Xingqiu from "./hydro/Xingqiu";
import Xinyan from "./pyro/Xinyan";
import YaeMiko from "./electro/YaeMiko";
import Yanfei from "./pyro/Yanfei";
import Yaoyao from "./dendro/Yaoyao";
import Yelan from "./hydro/Yelan";
import Yoimiya from "./pyro/Yoimiya";
import YunJin from "./geo/YunJin";
import Zhongli from "./geo/Zhongli";

const characters = [
  Albedo, // charBCs, selfMCs <= checkCharMC, findInput
  Alhaitham,
  Aloy, // charBCs <= checkCharMC, findInput
  Ayato, // selfMCs <= checkCharMC
  Amber,
  AnemoMC,
  Ayaka,
  Barbara,
  Beidou, // outdated: buff.index = 1
  Bennett, // charBCs, selfMCs <= checkCharMC
  Candace,
  Collei,
  Chongyun,
  Cyno,
  DendroMC,
  Diluc,
  Diona,
  Dori,
  ElectroMC, // charBCs <= checkCharMC
  Faruzan,
  Eula, // selfMCs <= checkCharMC
  Fischl, // selfMCs <= checkCharMC // outdated: buff.index = 0, 1, 3
  Ganyu, // selfMCs <= checkCharMC
  GeoMC,
  Gorou,
  HuTao,
  Heizou,
  Itto, // selfMCs <= checkCharMC
  Jean,
  Kazuha,
  Kaeya,
  Keqing,
  Klee,
  Kokomi, // charBCs <= checkCharMC
  Layla,
  Lisa,
  Mona,
  Nahida,
  Nilou,
  Ningguang,
  Noelle, // charBCs, selfMCs <= checkCharMC
  Qiqi,
  Raiden, // charBCs, selfMCs <= checkCharMC, findInput
  Razor,
  Rosaria,
  Sara,
  Sayu, // selfMCs <= checkCharMC, findInput
  Shenhe,
  Shinobu, // selfMCs <= checkCharMC
  Sucrose,
  Tartaglia,
  Tighnari,
  Thoma, // selfMCs <= checkCharMC
  Venti,
  Wanderer,
  Xiangling,
  Xiao,
  Xingqiu,
  Xinyan, // selfMCs <= checkCharMC
  YaeMiko, // outdated: buff.index = 1
  Yanfei, // outdated: buff.index = 1
  Yaoyao,
  Yelan,
  Yoimiya,
  YunJin, // charBCs, selfMCs <= checkCharMC
  Zhongli
];

export default characters;
